import { connect } from 'react-redux';
import RulesOperation from './duck/operation';
import PublicityModal from "./PublicityModal";

const mapStateToProps = (state) => {
    const isPublicityShow = state.publicity ? state.publicity.isPublicityShow : false;
    return { isPublicityShow };
};

const mapDispatchToProps = (dispatch) => {
    const hidePublicity = () => {
        return dispatch(RulesOperation.hidePublicityAction());
    };

    return {
        hidePublicity,
    };
};

const PublicityContainer = connect(
    mapStateToProps,
    mapDispatchToProps,
)(PublicityModal);


export default PublicityContainer;
